import styles from './style.m.less';

export default function ActivityDot() {
    return <span className={styles.dot}></span>;
}
